import Divider from "@mui/material/Divider";
import Typography from "@mui/material/Typography";

interface FormSectionHeadlineProps {
  children: string;
}

export const FormSectionHeadline = ({ children }: FormSectionHeadlineProps) => {
  return (
    <>
      <Typography variant="h6">{children}</Typography>
      <Divider
        sx={{
          width: "100%",
          mb: 2
        }}
      />
    </>
  );
};
